import * as React from "react";
import { Container as BootstrapContainer } from "react-bootstrap";

export default BootstrapContainer;
